export enum SkilledNeedsQuestionnaireItem {
  SKILLED_NEEDS = 'skilled-needs',
  SKILLED_NEEDS_NEED = 'skilled-needs/need',
  SKILLED_NEEDS_NEED_NAME = 'skilled-needs/need/name',
  SKILLED_NEEDS_NEED_SCORE = 'skilled-needs/need/score',
  SKILLED_NEEDS_NEED_PREVIOUS_NOTE = 'skilled-needs/need/previous-note',
  SKILLED_NEEDS_NEED_NOTE = 'skilled-needs/need/note',
  SKILLED_NEED_INITIALS_AUTHORIZATION = 'skilled-needs/initials-authorization'
}
